import toast from "react-hot-toast";
import { UPDATE_FEEDBACK_LIST } from "../../store/actionTypes";
import { createParams } from "../../utils/commonFunctions";
import { ENDPOINTS } from "../../utils/endPoints";
import {
  GET_API_CALL,
  PATCH_API_CALL,
  PUT_API_CALL,
} from "../../utils/services";

/**
 * @description Action for fetching all users that are reported
 * @returns state
 */
export const getAllFeedbacks = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_FEEDBACK_LIST, payload: { isLoading: true } });
    const { pageNo, limit, sortBy, sortOrder, status } =
      getState().FeedbackReducer;
    const params = createParams({
      pageNo,
      limit,
      sortBy,
      sortOrder,
      status,
    });
    GET_API_CALL(ENDPOINTS.REPORTS.FEEDBACK_LIST, params, (response) => {
      console.log("Feedback List Response :", response);
      if (response?.isSuccess) {
        let { data, total, totalPage, limit, pageNo } = response?.data;
        const payload = {
          total,
          totalPage,
          dataList: [...data],
          limit,
          pageNo,
          isLoading: false,
          status: status,
        };
        dispatch({
          type: UPDATE_FEEDBACK_LIST,
          payload: payload,
        });
      } else {
        dispatch({ type: UPDATE_FEEDBACK_LIST, payload: { isLoading: false } });
      }
    });
  };
};

export const getFeedbackDetails = (id, callback) => {
  return () => {
    GET_API_CALL(ENDPOINTS.REPORTS.FEEDBACK_DETAILS, `${id}`, (response) => {
      console.log("Feedback Details Response :", response);
      if (response.isSuccess) {
        callback(response?.data);
      } else callback({});
    });
  };
};

export const feedbackStatusHandler = (params, callback) => {
  return () => {
    const toastId = toast.loading("Updating");
    PUT_API_CALL(ENDPOINTS.FEEDBACK.STATUS + params, {}, (response) => {
      console.log("feedback Active Inactive Response :", response);
      if (response.isSuccess) {
        callback(response);
        toast.success("Feedback status updated successfully");
      }
      toast.dismiss(toastId);
    });
  };
};
